import React from "react";
import { FormControl, TextField, withStyles } from "@material-ui/core";
import { useTranslations } from "adapters/i18n";
const GoalPlanListFilter = ({ classes, filter, onChangeFilter }) => {
  const { t } = useTranslations();

  const onChangeFilterName = (event) => {
    onChangeFilter({ ...filter, name: event.target.value });
  };

  return (
    <FormControl id="buscar" className={classes.searchForm}>
      <TextField
        id="buscarMetas"
        inputProps={{ "data-testid": "goalPlanListFilterNameInput" }}
        value={filter.name}
        autoFocus
        label={t("common:actions.search")}
        className={classes.textField}
        placeholder={t("common:fields.placeholder-search-text")}
        onChange={onChangeFilterName}
        InputLabelProps={{
          shrink: true,
        }}
      />
    </FormControl>
  );
};

const styles = () => {
  return {
    searchForm: {
      display: "flex",
      flexDirection: "row",
    },
    textField: {
      width: "450px",
      marginRight: 16,
    },
  };
};

export default withStyles(styles)(GoalPlanListFilter);
